
import { React, useContext } from 'react';
import Styles from './PurchaseCard.module.scss';
import LocalPoliceOutlinedIcon from '@mui/icons-material/LocalPoliceOutlined';
import { useTranslation } from 'react-i18next';
import { useNavigate, AuthContext } from 'components/lib';

const PurchaseCard = ({
	data,
	handleProductAssociation,
	displayPrice,
	pricing,
	interactive = true,
	...props }) => {
	const navigate = useNavigate();
	const prices = pricing;
	const { t } = useTranslation();
	const authContext = useContext(AuthContext);
	const currencySymbol = authContext?.user.currencySymbol || '';

	return (
		<>
			<div data-tooltip-id="purchase_labs" className={Styles.container}
				data-tooltip-content={JSON.stringify(data)}
				data-some-relevant-attr={data.id}
				style={{
					transition: "background-color 0.5s ease",
					cursor: interactive ? 'pointer' : 'default',
				}}
				onClick={() => {
					if (!interactive) return;

					if (data.association) {
						// if association exists show message
						handleProductAssociation(data.association);
					} else {
						// Navigate to individual purchase page
						navigate(`/labs/purchase/${data.id}`);
					}
				}}
			>
				<div id='contentInfo' className={Styles.contentInfo}>
					{/* Image Part */}
					< div className={Styles.imageContainer} >
						<img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data.icon}`} className={Styles.courseImage} alt="courseImg" />
					</div>
					{/* Content Part */}
					< div className={Styles.contentContainer} >
						<p className={Styles.headerText} style={{ marginTop: data?.active === false ? "-10px" : "" }}>{data.name}</p>
						{data?.active === false ?
							<p style={{
								fontSize: "14px",
								fontWeight: 'bold',
								marginBottom: '-10px'

							}}>
								{t('Components.PurchaseCard.renew')}
							</p>
							: null
						}
					</div>
				</div>
				{displayPrice && <div className={Styles.seperator} ></div>}
				{/*Button  Part */}
				{displayPrice && <div id='buttonContainer' className={Styles.buttonContainer}>
					<div key={prices?.product_id} style={{ display: 'flex', flexDirection: 'column' }}>
						<div id='labPrice' className={Styles.labPrice} key={prices?.product_id}>

							<span style={{
								textDecoration: "line-through",
								marginRight: '4px',
								fontSize: '16px'
							}}>
								{currencySymbol}{prices?.actual_price ?? 0 }<small>/{prices?.interval || 0}M</small>
							</span>
						</div>
						<div className={Styles.price}>
							{currencySymbol}{prices?.price ?? 0}/
							<small>{prices?.interval + 'M' ?? 0}</small>
						</div>
					</div>
					<button className={Styles.buyButton}>
						{data.association && (
							<LocalPoliceOutlinedIcon sx={{ color: 'darkgreen' }} />
						)}
					</button>
				</div>}
			</div >
		</>
	);
};

export default PurchaseCard;
